import React, { useEffect } from "react";
import PropTypes from "prop-types";
import MainContent from "../../MainContent";
import styles from "./ErrorScreen.module.css";
import { useNavigate } from "react-router-dom";

const ErrorScreen = ({ errorCondition, showContactInfo = true, formData }) => {
  const navigate = useNavigate();
  // Scroll to top when error screen is shown
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className={styles.mainContainer}>
      <MainContent>
        <div className={styles.errorContent}>
          <div className={styles.errorSection}>
            {/* Error Message */}
            <div className={styles.errorMessage}>
              <h4 className={styles.errorHeading}>
                <strong>
                  <br></br>
                  Sorry, we are unable to complete your online quote at this
                  time.
                  <br></br>
                </strong>
              </h4>
              <h4 className={styles.errorTitle}>
                To get help with your quote, please call us on{" "}
                <strong>
                  <a href="tel:0333 666 0276" className={styles.phoneLink}>
                    0333 666 0276{" "}
                  </a>
                </strong>
                <p />
                <br />
                Lines are open Mon – Thu 8.30am – 5.00pm and Fri 8.30am –
                4.30pm.
                <br />
                <br />
              </h4>

              <button
                onClick={() => {
                  errorCondition(false);
                  navigate("/", { state: { formData } });
                  sessionStorage.setItem("navigated", "true");
                }}
                className={styles.backButton}
              >
                Back to Quote
              </button>
            </div>

            {showContactInfo && (
              <div className={styles.contactSection}>
                <h2 className={styles.contactTitle}>Prefer to call us?</h2>

                <div className={styles.contactInfo}>
                  <p className={styles.contactText}>
                    Call us on{" "}
                    <a href="tel:03336660276" className={styles.phoneLink}>
                      0333 666 0276
                    </a>{" "}
                    to speak to a dedicated Business Energy Advisor
                  </p>
                </div>

                <p className={styles.hoursText}>
                  Lines open Mon - Thu 8.30am - 5.00pm and Fri 8.30am - 4.30pm
                </p>

                <div className={styles.legalLinks}>
                  <a href="/terms" className={styles.legalLink}>
                    Terms of use
                  </a>
                  <a
                    href="https://www.engie.co.uk/privacy-notice-and-cookies/"
                    className={styles.legalLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy policy
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* <Footer /> */}
      </MainContent>
    </div>
  );
};

ErrorScreen.propTypes = {
  errorCondition: PropTypes.func.isRequired,
  showContactInfo: PropTypes.bool,
  formData: PropTypes.object,
};

export default ErrorScreen;
